import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest } from '../../../components/utils/api';

export default class DemoSearchEngineList extends Component {
	constructor(props) {
        super(props);
        this.state = {
            searchEngines: []
        }
    }
    
    getSearchEngines() {
        apiGetRequest("search/demo/list/").then((data) => {
            this.setState({searchEngines: data});
        })
    }

    componentDidMount() {
        this.getSearchEngines();
        this.props.mixpanel.track("Viewed Search Engine List")
    }

	render() {
		return (
			<div class={cx("home")}>
                <div class={cx("content")}>
                    <h2>Check out some search engines:</h2>
                    <div class={cx("options")}>
                        {this.state.searchEngines.map((item) => (
                            <div class={cx("option-base")} onClick={() => {
                                this.props.mixpanel.track("Clicked on Demo Search Engine", {
                                    search_engine_id: item.id
                                });
                                route("/demo/engine/" + item.id);
                            }}>
                                <p class={cx("emoji")}>🔍</p>
                                <p class={cx("name")}>{item.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./routes/demo/demoList/index.js